export default function scrollIntoViewById(id?: string) {
  if (!id) return;
  const el = document.getElementById(id);
  el?.scrollIntoView();
}
